export default function Section16() {
    const processSteps = [
        {
            title: "Discovery & Strategy",
            description:
                "We start by understanding your goals, audience, and business challenges to create a roadmap for success.",
        },
        {
            title: "Design & Prototyping",
            description:
                "We build wireframes and interactive prototypes to test the design and user flow before development begins.",
        },
        {
            title: "Development & Integration",
            description:
                "Our development team gets to work, using the latest technologies to bring your vision to life.",
        },
        {
            title: "QA & Testing",
            description:
                "Rigorous testing across devices and browsers to ensure a flawless user experience.",
        },
        {
            title: "Launch & Optimization",
            description:
                "We deploy your site with continuous monitoring and optimization for peak performance.",
        },
        {
            title: "Ongoing Support & Growth",
            description:
                "Post-launch, we provide ongoing updates, maintenance, and scaling to ensure your website evolves as your business grows.",
        },
    ];

    return (
        <div className="Section16 py-[80px] md:py-[100px] bg-[white]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our Process for the Best <span className="text-[#DA2128]">Website Development</span>
                </h2>
                <h3 className="mt-6 text-[#DA2128] text-[18px] md:text-[20px] font-semibold max-w-[600px] mx-auto">
                    A Transparent Process, From Discovery to Launch
                </h3>
                <p className="mt-2 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    At Mean3, we follow a proven step-by-step process that ensures each project is delivered on time and exceeds expectations. From strategy to post-launch support, we’ve got you covered.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${
                            index % 2 === 0
                                ? "bg-[#E42E35] text-white" // red card
                                : "bg-white text-[#151515]" // normal white card
                        }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>

            {/* CTA Button */}
            <div className="text-center mt-12">
                <a
                    href="https://mean3.com/contact-mean3"
                    className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
                >
                    Learn About Our Process
                </a>
            </div>
        </div>
    );
}
